module.exports = __webpack_public_path__ + "img/excel.a12a7203.svg";